import { xhttp } from "../../Fetchv2.js";
import { PGSchema } from "../../schemas/pg.schema.js";

export class UsersCrud {
	async getUsers(query: { take?: number; skip?: number; where?: any }) {
		return xhttp<{ users: PGSchema.users[]; total?: number }>("/admin/usersv2/GET", "POST", query);
	}

	async createUsers(usersData: Partial<PGSchema.users>) {
		return xhttp<{ user: PGSchema.users }>("/admin/usersv2", "POST", usersData);
	}

	async updateUsers(id: string, usersData: Partial<PGSchema.users>) {
		return xhttp<{ user: PGSchema.users }>(`/admin/usersv2/${id}`, "PUT", usersData);
	}

	async deleteUsers(id: string) {
		return xhttp<{ user: PGSchema.users }>(`/admin/usersv2/${id}`, "DELETE");
	}
}
